import { render } from "./BannerCarousel.vue?vue&type=template&id=d0b41dc0&scoped=true"
import script from "./BannerCarousel.vue?vue&type=script&lang=js"
export * from "./BannerCarousel.vue?vue&type=script&lang=js"

import "./BannerCarousel.vue?vue&type=style&index=0&id=d0b41dc0&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b41dc0"]])

export default __exports__